var _defs, _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFounderSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32 24) rotate(45) scale(80)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B6F64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#073F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#052E2A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    x: 8,
    y: 8,
    width: 80,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 14,
    stdDeviation: 10,
    floodColor: "#00675F",
    floodOpacity: 0.18
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 46,
    r: 35,
    fill: "url(#g)",
    filter: "url(#s)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 46,
    r: 34.25,
    stroke: "#FFF8EE",
    strokeOpacity: 0.42,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 25.5C51.35 37.95 56.05 42.65 68.5 46C56.05 49.35 51.35 54.05 48 66.5C44.65 54.05 39.95 49.35 27.5 46C39.95 42.65 44.65 37.95 48 25.5Z",
    fill: "#FFF8EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 19.5C63.62 23.64 65.36 25.38 69.5 26.5C65.36 27.62 63.62 29.36 62.5 33.5C61.38 29.36 59.64 27.62 55.5 26.5C59.64 25.38 61.38 23.64 62.5 19.5Z",
    fill: "#D7B676",
    opacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFounderSparkle);
export default __webpack_public_path__ + "static/media/founder-sparkle.0a93be2665213d21619c13d4bab4c60b.svg";
export { ForwardRef as ReactComponent };